import type { FC, ReactNode } from "react";

interface FormHeaderProps {
	title: string;
	description: string | ReactNode;
}

export const RegistrationFormHeader: FC<FormHeaderProps> = ({ title, description }) => {
	return (
		<div className="flex w-full max-w-md flex-col gap-2">
			<h1 className="text-brand-dark-900 text-xl font-semibold">{title}</h1>
			<p className="text-brand-dark/70 text-sm leading-relaxed font-normal sm:text-justify">{description}</p>
		</div>
	);
};
